// @flow
import * as React from 'react';
import { isEmpty } from 'lodash';
import { View } from 'grommet-icons';
import { Box, Button, Text } from 'grommet';
import ReactTooltip from 'react-tooltip';

type Props = {
    row: {
        [string]: ?Object,
        _original: {
            uuid: string,
            [string]: ?Object,
        },
    },
    data: Object,
    icon?: React.Element<>,
};

const WSTableViewerComponent = (rowProps: Props) => {
    const {
        row, data, icon,
    } = rowProps;

    if (isEmpty(data)) {
        return null;
    }

    const openedBy = data[row._original.uuid];
    return !isEmpty(openedBy) ? (
        <>
            <Button
                data-tip
                data-for={row._original.uuid}
                icon={icon || <View size="medium" />}
                position="right"
            />
            <ReactTooltip
                id={row._original.uuid}
                effect="solid"
                place="top"
                className="react-tooltip"
            >
                <Box align="center">
                    {openedBy.map(({ username }) => <Text key={username}>{username}</Text>)}
                </Box>
            </ReactTooltip>
        </>
    ) : null;
};

export default WSTableViewerComponent;
